// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
import { __extends } from "tslib";
var UserNotDefinedError = /** @class */ (function (_super) {
  __extends(UserNotDefinedError, _super);
  function UserNotDefinedError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, UserNotDefinedError.prototype);
    return _this;
  }
  return UserNotDefinedError;
})(Error);
export { UserNotDefinedError };
var ProjectCreationError = /** @class */ (function (_super) {
  __extends(ProjectCreationError, _super);
  function ProjectCreationError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, ProjectCreationError.prototype);
    return _this;
  }
  return ProjectCreationError;
})(Error);
export { ProjectCreationError };
var ProjectUserCreationError = /** @class */ (function (_super) {
  __extends(ProjectUserCreationError, _super);
  function ProjectUserCreationError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, ProjectUserCreationError.prototype);
    return _this;
  }
  return ProjectUserCreationError;
})(Error);
export { ProjectUserCreationError };
var DuplicateNameError = /** @class */ (function (_super) {
  __extends(DuplicateNameError, _super);
  function DuplicateNameError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, DuplicateNameError.prototype);
    return _this;
  }
  return DuplicateNameError;
})(Error);
export { DuplicateNameError };
var InvalidNameError = /** @class */ (function (_super) {
  __extends(InvalidNameError, _super);
  function InvalidNameError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, InvalidNameError.prototype);
    return _this;
  }
  return InvalidNameError;
})(Error);
export { InvalidNameError };
var NameTooLongError = /** @class */ (function (_super) {
  __extends(NameTooLongError, _super);
  function NameTooLongError(message) {
    var _this = _super.call(this, message) || this;
    Object.setPrototypeOf(_this, NameTooLongError.prototype);
    return _this;
  }
  return NameTooLongError;
})(Error);
export { NameTooLongError };
